/**
 * 請求書一覧画面
 */
import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { useDispatch } from "react-redux";
import rootScope from "../../store/rootScopeStore";
import stateStore from "../../store/stateStore";
import authService from "../../services/common/authService";
import myGrid from "../../store/myGridStore";
import constMap from "../../const/const";
import errMsgService from "../../services/common/errMsgService";
import asyncService from "../../services/common/asyncService";
import skyService from "../../services/sky/skyService";
import dialogService from "../../services/common/dialogService";
import { formatDateToText } from "../../util/util";
import FromToTextBox from "../common/FromToTextBox";
import IsdTextboxYmd from "../common/IsdTextboxYmd";
import CustomGrid from "../common/CustomGrid";
import IsdEditable from "../common/isdEditable";
import "../../css/sky/Skyf101.css";

/**
 * 
 * @param {any} props 
 * @returns
 */
const Skyf101 = observer((props) => {
    const [gridData, setGridData] = useState([]);
    const dispatch = useDispatch();
    const billymdFromTo = useRef(null);
    useEffect(() => {
        let owuser = authService.getUser();

        stateStore.state = {
            billymdFrom: "",
            billymdTo: "",
        }


        myGrid.props = {
            columnDefs: [
                {
                    Header: '',
                    accessor: 'button',
                    Cell: IsdEditable,
                    editor: {
                        component: 'button',
                        clickFunc: (event, row, cell, name, original) => {
                            download(original.billId, original.fileName);
                        },
                        view: (row, cell, name, original) => {
                            return (<span>ダウンロード</span>);
                        },
                        linkTo: (row, cell, name, original) => {
                            return ''
                        }
                    },
                    className: "cell-center",
                    width: 100,
                },
                {
                    Header: '請求年月日',
                    accessor: 'billymd',
                    width: 100,
                },
                {
                    Header: '請求金額',
                    accessor: 'billPrice',
                    className: 'cell-right',
                    width: 100,
                }
            ]
        }

        rootScope.footer = {
            endBtn: {
                hide: false
            }
        };

        let currentDate = new Date();
        let currentDateFormat = formatDateToText(currentDate, constMap.format.yyyymm);
        stateStore.state.billymdFrom = currentDateFormat;
        stateStore.state.billymdTo = currentDateFormat;
        billymdFromTo.current.focus();
    }, []);

    /**
     * 請求書ダウンロード
     * @param {number} billId 
     */
    const download = (billId, fileName) => {
        const params = {
            billId: billId,
        }
        dispatch(asyncService.async(skyService.skya102(params), (response) => {
            const url = URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            link.click();
            URL.revokeObjectURL(url);
            link.remove();
        }));
    }

    const handleInputToBlur = event => {
        const { value } = event.target;
        errMsgService.delMsgKey("billymdFromTo");
        if (stateStore.state?.billymdFrom && value) {
            const fromDate = new Date(stateStore.state?.billymdFrom);
            const dateNextYear = formatDateToText(fromDate.setFullYear(fromDate.getFullYear() + 1), constMap.format.yyyymm);
            // if (value > dateNextYear) {
            //     errMsgService.addMsgKey('EJYU0100', 'skyymdFromTo');
            // }
        }
    };

    const search = () => {
        if (stateStore.state?.billymdFrom && stateStore.state?.billymdTo) {
            let params = {
                skyymdfrom: stateStore.state?.billymdFrom ? stateStore.state?.billymdFrom : '',
                skyymdto: stateStore.state?.billymdTo ? stateStore.state?.billymdTo : '',
            }

            dispatch(asyncService.async(skyService.skya101(params), (response) => {
                if (response.data.messageId) {
                    dialogService.okDialog(response.data.messageId, response.data.message);
                } else {
                    let datas = [];
                    Object.values(response.data).map(item => {
                        let rowDatas = {};
                        rowDatas.billymd = item.billymd; // 請求年月日
                        rowDatas.billPrice = item.billPrice.toLocaleString(); // 請求金額
                        rowDatas.billId = item.billId; // 請求書レコードID
                        rowDatas.fileName = item.fileName; // 請求書ファイル名

                        datas.push(rowDatas);
                    });
                    setGridData(datas);
                }
            }));
        } else {
            dialogService.okDialog('ESKY0100');
        }
    }

    return (
        <div className="skyf-wrap">
            <div>
                <div className="search-area-wrap py-4">
                    <div>
                        <label htmlFor="billymdFromTo">請求年月</label>
                        <div className="jyuf105-input-display ml50" >
                            <FromToTextBox className="jyuf105-input-display" id="billymdFromTo" name="billymdFromTo" fromValue="billymdFrom" toValue="billymdTo">
                                <IsdTextboxYmd className="w105" format="yyyy/MM" name="billymdFrom" value={stateStore.state?.billymdFrom}> </IsdTextboxYmd>
                                <span className="ml10" ref={billymdFromTo} >~</span>
                                <div className="ml10">
                                    <IsdTextboxYmd className="w105" format="yyyy/MM" name="billymdTo" value={stateStore.state?.billymdTo}
                                        onBlur={handleInputToBlur}></IsdTextboxYmd>
                                </div>
                            </FromToTextBox>
                            <button className="btn btn-search ml-4" onClick={search}>検索</button>
                        </div>
                    </div>
                    {/* <div className="bill_search">
                        <button className="btn btn-search" onClick={search}>検索</button>
                    </div> */}
                </div>
                <div id="gridWrapper" className="mt20" style={{ marginTop: '20px' }}>
                    <CustomGrid data={gridData} outsideHeight={355} minColumns={2} customItemSize={140} customClass={'Skyf101'} />
                </div>
            </div>
        </div>
    );
});

export default Skyf101;